import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('board_harmonisation_m2_filter_refinement');
	},
};
